module.exports = __webpack_public_path__ + "img/arrow_down_blue.d9cc2ade.svg";